<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
  <div class="header d-flex justify-content-between align-items-center" (click)="toggleNotesSection()"
    [ngClass]="{ 'expanded': notesSectionExpanded, 'collapsed': !notesSectionExpanded }">
    <h5 class="mb-0 panel-title">Notes</h5>
    <button type="button" class="toggle-panel" aria-label="Toggle" [attr.aria-expanded]="notesSectionExpanded"
      (click)="$event.stopPropagation(); notesSectionExpanded = !notesSectionExpanded">
      <span class="toggle-icon">
        <i class="fa fa-chevron-up" *ngIf="notesSectionExpanded" aria-hidden="true"></i>
      <i class="fa fa-chevron-down" *ngIf="!notesSectionExpanded" aria-hidden="true"></i>
      </span>
    </button>
  </div>

  <div *ngIf="notesSectionExpanded" class="panel-body">
    <div class="tab-content border rounded my-applications-container p-0" id="communication_notes_div_tabcontent"
      style="margin-left: 0; margin-right: 0;">
      <div class="p-2 align-items-center mb-3" id="communication_notes_div_headeractions">
        <div class="row row-alignment" style="margin-left: 0 !important; margin-right: 0 !important;">
          <div class="queues-export-btn-group">
            <button mat-icon-button class="icon-btn" id="communication_notes_button_export" matTooltip="Export"
              matTooltipPosition="above" matTooltipClass="custom-tooltip" (click)="downloadNotesExcel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                  fill="currentColor" />
              </svg>
            </button>
          </div>

          <div class="queues-column-chooser-group">
            <button mat-icon-button class="icon-btn" id="communication_notes_columnchooser_btn"
              matTooltip="Column Chooser" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              (click)="showNotesColumnChooser = !showNotesColumnChooser">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                  fill="currentColor" />
              </svg>
            </button>

            <div *ngIf="showNotesColumnChooser" class="queues-column-chooser-dialog column-chooser-dialog"
              id="communication_notes_div_columnchooser">
              <div class="queues-column-chooser-header" id="communication_notes_div_columnheader">
                Column Chooser
                <button class="column-chooser-close" id="communication_notes_button_close"
                  (click)="closeNotesColumnChooser()">&times;</button>
              </div>
              <div class="column-chooser-list font-14">
                <label *ngFor="let col of allNotesColumns" class="column-chooser-checkbox" [class.disabled-column]="col.key === 'type'">
                  <input type="checkbox" [id]="'communication_notes_column_chooser_' + col.key" [value]="col.key"
                    [checked]="visibleNotesColumns[col.key]" (click)="onNotesColumnClick(col.key)" [disabled]="col.key === 'type'"/>
                  {{ col.label }}
                </label>
              </div>
            </div>
          </div>

          <div class="degree-btn">
            <button class="btn-primary btn-cls" pTooltip="Add Note" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"  (click)="onAddNote()"  *ngIf="!showAddNoteForm"><span class="material-symbols-outlined">add_circle</span>Add Note</button>
          </div>
        </div>
      </div>
    </div>

    <div class="add-note-panel" *ngIf="showAddNoteForm">
      <h6 _ngcontent-ng-c1345613618="" class="add-note-title">Add Note</h6>
      <form [formGroup]="addNoteForm">
        <div class="row ml-0 mr-0">
          <div class="col-sm-12 col-md-3 col-lg-3 mb-3 relPos">
            <label for="communication_note_date" class="form-label custom-req-label">Date <span class="requiredfield text-danger">*</span></label>
            <div class="input-group ssn-input-group">
              <input type="text" id="communication_note_date" class="form-control formField date-uppercase mt-1"
                formControlName="date" placeholder="Select Test Date" maxlength="10" (focus)="onDateFocus()"
                (blur)="onDateBlur()" (input)="formatDateInput($event)"
                [ngClass]="{ 'is-invalid': addNoteForm.get('date')?.invalid && addNoteForm.get('date')?.touched }" />
              <span class="ssn-eye mt-1">
                <button type="button" id="btn_lookup_dob_open_calendar" class="mt-1 p-0 eye absoloutePos" tabindex="7"
                  (click)="openDatePicker($event)" (keypress)="openDatePicker($event)" pTooltip="Open Calendar"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                  aria-label="Open date picker">
                  <span class="material-symbols-outlined f-20 cal">calendar_month</span>
                </button>
              </span>
            </div>
            <div id="log_date_error" *ngIf="addNoteForm.get('date')?.touched && addNoteForm.get('date')?.errors as logErrors">
              <div *ngIf="logErrors['futureDate'] || logErrors['required']" class="text-danger mt-1 err-font">Select a valid test date.</div>
              <div *ngIf="logErrors['beforeDob']" class="text-danger mt-1 err-font">Date cannot be earlier than your Date of Birth.</div>

            </div>
          </div>

          <div class="col-sm-12 col-md-3 col-lg-3 relPos mt-1">
            <label for="communication_note_type" class="form-label custom-req-label">Note Type <span class="requiredfield text-danger">*</span></label>
              <!-- <select id="communication_note_type" class="formField" formControlName="noteType"
                [ngClass]="{ 'is-invalid': addNoteForm.get('noteType')?.invalid && addNoteForm.get('noteType')?.touched }">
                <option value="" disabled>Select</option>
                <option *ngFor="let type of noteTypeOptions" [value]="type.key">{{ type.value }}</option>
              </select> -->
              <p-dropdown inputId="communication_note_type" [options]="noteTypeOptions" formControlName="noteType" optionLabel="value"
                optionValue="key" placeholder="Select Note Type" [filter]="true" filterBy="value" filterMatchMode="contains"
                styleClass="ufcustom-req-dropdown" [ngClass]="{
                  'is-invalid':
                    addNoteForm.get('noteType')?.invalid &&
                    addNoteForm.get('noteType')?.touched
                }">
              </p-dropdown>
            <div *ngIf="addNoteForm.get('noteType')?.touched && addNoteForm.get('noteType')?.errors?.['required']" class="text-danger mt-1 err-font">Note Type is required.</div>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6 relPos">
            <label for="communication_supporting_document" class="form-label custom-req-label">
              Supporting Document
            </label>
          
            <div class="supporting-doc-row-v1">
              <!-- Left file icon slot -->
              <div class="doc-icon-slot">
                <span class="material-symbols-outlined">
                  file_save
                </span>
              </div>
          
              <!-- Readonly filename input -->
              <input id="communication_supporting_document" type="text" class="form-control formField doc-name-input"
                formControlName="supportingDocument" readonly />
          
              <!-- Replace file button -->
              <button type="button" class="replace-file-btn" (click)="onOpenUploadWarning()" pTooltip="Upload file"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip">
                <img src="assets/images/neveda-images/upload.svg" alt="Upload" width="24" height="24" />
                   Upload file
              </button>
            </div>
            <!-- <p class="doc-hint-text">Supported formats: PDF, JPG, JPEG, PNG · Max 15 MB</p> -->
            <div
              *ngIf="addNoteForm.get('supportingDocument')?.touched && addNoteForm.get('supportingDocument')?.errors?.['required']"
              class="text-danger mt-1 err-font">
              Supporting Document is Required
            </div>
          </div>
        </div>

        <div class="row ml-0 mr-0">
          <div class="col-sm-6 relPos">
            <label for="communication_note_text" class="form-label custom-req-label">Note <span class="requiredfield text-danger">*</span></label>
            <div class="input-group ssn-input-group">
              <textarea id="communication_note_text" rows="3" class="popup-autoheighttextarea form-control"
                formControlName="notes" placeholder="Enter Notes" (input)="onInput()"
                [ngClass]="{ 'is-invalid': addNoteForm.get('notes')?.invalid && addNoteForm.get('notes')?.touched }"  maxlength="700"></textarea>
            </div>
            <div id="notes_date_error" *ngIf="addNoteForm.get('notes')?.touched && addNoteForm.get('notes')?.errors as notesError">
              <div *ngIf="notesError['required']" class="text-danger mt-1 err-font">Notes is required.</div>
            </div>
          </div>
        </div>

        <!-- <div class="row ml-0 mr-0 mt-2">
          <div class="col-sm-12 col-md-5 col-lg-5 relPos">
            <label for="communication_supporting_document">Supporting Document <span class="requiredfield text-danger">*</span></label>
            <div class="supporting-doc-row">
              <input id="communication_supporting_document" type="text" class="form-control formField" formControlName="supportingDocument" readonly />
              <button type="button" class="upload-icon-btn" (click)="onOpenUploadWarning()" title="Upload">
                <img src="assets/images/neveda-images/upload.svg" alt="Upload" width="18" height="18" />
              </button>
            </div>
            <div *ngIf="addNoteForm.get('supportingDocument')?.touched && addNoteForm.get('supportingDocument')?.errors?.['required']" class="text-danger mt-1 err-font">Required</div>
          </div>
        </div> -->

        <div class="row mb-3 ml-0 mr-0 mt-3">
          <div class="col text-right pt-3 pr-0 manage-action">
            <button type="button" class="btn btn-outline-primary lookup-communication-btn-cancel" (click)="onCancelAddNote()">Cancel</button>
            <button type="button" class="btn btn-primary ml-2 lookup-communication-btn-save" (click)="onSaveAddNote()">Save</button>
          </div>
        </div>
      </form>
    </div>

   <app-data-grid [config]="notesGridData" [paging]="{ enabled: false }" [wordWrapEnabled]="false">
      <ng-template #actionsTemplate let-data let-rowIndex="index">
        <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for note ' + (data.document_id ?? '')">
          <span class="action-span-wrapper">
            <button type="button" class="action-icon-button"
              pTooltip="Edit" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
              (click)="onEditNote(data); $event.stopPropagation()">
              <!-- <i class="fa fa-edit" aria-hidden="true"></i> -->
               <svg width="24" height="24" viewBox="4 4 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                    fill="#444444" />
                </svg>
            </button>
          </span>
          <span class="action-span-wrapper view-wrapper">
            <button type="button" class="action-icon-button"
              [disabled]="!hasValidDocumentId(data)"
              pTooltip="View"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
              [attr.aria-label]="'View document ' + (data.document_id ?? '')"
              (click)="onViewNote(data); $event.stopPropagation()">
              <span class="material-symbols-outlined">visibility</span>
            </button>
          </span>
          <span class="action-span-wrapper download-span ml-1">
            <button type="button" class="action-icon-button"
              [disabled]="!data.document_id"
              pTooltip="Download"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
              [attr.aria-label]="'Download document ' + (data.document_id ?? '')"
              (click)="downloadNoteDocument(data); $event.stopPropagation()">
            <span class="material-symbols-outlined">download</span>
            </button>
          </span>
          <span class="action-span-wrapper delete-span ml-1"  *ngIf="isDeletionAllowed(data)">
            <button type="button" class="action-icon-button deletebtn"
              pTooltip="Delete"  tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
              [attr.aria-label]="'Delete note ' + (data.document_id ?? '')"
              (click)="openDeleteModal(data); $event.stopPropagation()">
                  <!-- <i class="fa fa-trash" aria-hidden="true"></i> -->
                  <span class="material-symbols-outlined">delete</span>
            </button>
          </span>
        </div>
      </ng-template>
    </app-data-grid>
  </div>
  </div>
</div>

<div class="row ml-0 mr-0 lookup-user-personal-wrap">
  <div class="panel-blue">
  <div class="header d-flex justify-content-between align-items-center" (click)="toggleEmailSection()"
    [ngClass]="{ 'expanded': emailLogSectionExpanded, 'collapsed': !emailLogSectionExpanded }">
    <h5 class="mb-0 panel-title">Email Log</h5>
    <button type="button" class="toggle-panel" aria-label="Toggle" [attr.aria-expanded]="emailLogSectionExpanded"
      (click)="$event.stopPropagation(); emailLogSectionExpanded = !emailLogSectionExpanded">
      <!-- <span class="toggle-icon">
        <i class="fas fa-chevron-up" *ngIf="emailLogSectionExpanded" aria-hidden="true"></i>
        <i class="fas fa-chevron-down" *ngIf="!emailLogSectionExpanded" aria-hidden="true"></i>
      </span> -->
      <i class="fa fa-chevron-up" *ngIf="emailLogSectionExpanded" aria-hidden="true"></i>
      <i class="fa fa-chevron-down" *ngIf="!emailLogSectionExpanded" aria-hidden="true"></i>
    </button>
  </div>

  <div *ngIf="emailLogSectionExpanded" class="panel-body">
    <div class="tab-content border rounded my-applications-container p-0" id="communication_email_div_tabcontent"
      style="margin-left: 0; margin-right: 0;">
      <div class="p-2 align-items-center mb-3" id="communication_email_div_headeractions">
        <div class="row row-alignment" style="margin-left: 0 !important; margin-right: 0 !important;">
          <div class="queues-export-btn-group">
            <button mat-icon-button class="icon-btn" id="communication_email_button_export" matTooltip="Export"
              matTooltipPosition="above" matTooltipClass="custom-tooltip" (click)="downloadEmailExcel()">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                  fill="currentColor" />
              </svg>
            </button>
          </div>

          <div class="queues-column-chooser-group">
            <button mat-icon-button class="icon-btn" id="communication_email_columnchooser_btn"
              matTooltip="Column Chooser" matTooltipPosition="above" matTooltipClass="custom-tooltip"
              (click)="showEmailColumnChooser = !showEmailColumnChooser">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                  fill="currentColor" />
              </svg>
            </button>

            <div *ngIf="showEmailColumnChooser" class="queues-column-chooser-dialog column-chooser-dialog"
              id="communication_email_div_columnchooser">
              <div class="queues-column-chooser-header" id="communication_email_div_columnheader">
                Column Chooser
                <button class="column-chooser-close" id="communication_email_button_close"
                  (click)="closeEmailColumnChooser()">&times;</button>
              </div>
              <div class="column-chooser-list font-14">
                <label *ngFor="let col of allEmailColumns" class="column-chooser-checkbox"
                  [class.disabled-column]="col.key === 'recipient'">
                  <input type="checkbox" [id]="'communication_email_column_chooser_' + col.key" [value]="col.key"
                    [checked]="visibleEmailColumns[col.key]"
                    [disabled]="col.key === 'recipient'"
                    (click)="col.key !== 'recipient' && onEmailColumnClick(col.key)" />
                  {{ col.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #emailActionsTemplate let-data let-rowIndex="index">
      <div class="action-buttons-container" [attr.data-row]="rowIndex" role="group" [attr.aria-label]="'Actions for email ' + (data.subject ?? '')">
        <span class="action-span-wrapper view-wrapper">
          <button type="button" class="action-icon-button"
            pTooltip="View"
            tooltipPosition="top"
            tooltipStyleClass="pcustom-tooltip"
            [attr.aria-label]="'View email ' + (data.subject ?? '')"
            (click)="viewEmailLog(data); $event.stopPropagation()">
            <span class="material-symbols-outlined ">visibility</span>
          </button>
        </span>
        <!-- <span class="action-span-wrapper download-span ml-1">
          <button type="button" class="action-icon-button"
            pTooltip="Download"
            tooltipPosition="top"
            tooltipStyleClass="pcustom-tooltip"
            [attr.aria-label]="'Download email ' + (data.subject ?? '')"
            (click)="downloadEmailLog(data); $event.stopPropagation()">
            <span class="material-symbols-outlined">download</span>
          </button>
        </span> -->
        <span class="action-span-wrapper resend-span ml-1">
          <button type="button" class="action-icon-button"
            pTooltip="Resend Email"
            tooltipPosition="top"
            tooltipStyleClass="pcustom-tooltip"
            [attr.aria-label]="'Resend email ' + (data.subject ?? '')"
            (click)="resendEmailLog(data); $event.stopPropagation()">
          <span class="material-symbols-outlined">
            mail
          </span>
          </button>
        </span>
      </div>
    </ng-template>
    <app-data-grid class="email-log-grid" [config]="emailGridData" [paging]="{ enabled: false }" [actionsTemplateRef]="emailActionsTemplate" [wordWrapEnabled]="false"></app-data-grid>
  </div>
  </div>
</div>

<ng-template #viewEmailModal>
  <div class="view-email-modal-content">
    <div class="view-email-modal-header">
      <h4>View Email</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeViewEmailModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="view-email-modal-body">
      <div class="view-email-card">
        <div class="view-email-subject-row">
          <!-- <span class="view-email-subject-label">Email Subject :</span> -->
          <!-- <span class="view-email-subject-value">{{ getEmailFieldValue(selectedEmailLog, ['subject', 'email_subject']) }}</span> -->
           <span class="view-email-subject-value"
                pTooltip="{{ selectedEmailLog?.subject_full }}"
                tooltipPosition="top"
                tooltipStyleClass="pcustom-tooltip">
            {{ getEmailFieldValue(selectedEmailLog, ['subject', 'email_subject']) }}
          </span>
        </div>

        <div class="view-email-message-row">
          <div class="view-email-message-content" 
               [innerHTML]="sanitizedEmailBody">
          </div>
        </div>
      </div>
    </div>

    <div class="view-email-modal-footer">
      <button type="button" class="btn btn-primary" (click)="closeViewEmailModal()">Close</button>
    </div>
  </div>
</ng-template>

<ng-template #resendEmailModal>
  <div class="resend-email-modal-content">
    <div class="resend-email-modal-header">
      <h4>Resend Email</h4>
      <button type="button" class="close" aria-label="Close" (click)="closeResendEmailModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="resend-email-modal-body">
      <p class="resend-email-message">This email has already been sent to the applicant. Are you sure you want to resend it?</p>
    </div>

    <div class="resend-email-modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="closeResendEmailModal()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="confirmResendEmail()">Resend Email</button>
    </div>
  </div>
</ng-template>

<ng-template #uploadModel let-modal>
  <div class="upload-form-popup">
    <div class="form-modal-header p-4 d-flex justify-content-between">
      <h4 class="modal-title">Upload Files</h4>
      <button type="button" class="close" aria-label="Close" (click)="showCancelUploadConfirmation()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
      <div class="mb-3">
        <div class="upload-drop-area" (click)="fileInputRef.click()" (dragover)="$event.preventDefault()"
          (dragleave)="$event.preventDefault()" (drop)="onDropFile($event)">
          <div class="upload-drop-content">
            <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
            <span>Drag &amp; drop or <span class="choose-file-link">choose a file</span> to upload</span>
          </div>
          <input type="file" #fileInputRef class="file-input-hidden"  accept=".pdf,.jpg,.jpeg,.png" (click)="clearFileInput($event)" (change)="handleFileUpload($event)" />
        </div>

        <div class="no-file-uploaded mt-20" [ngClass]="!uploadData.file ? 'no-file-uploaded border-0' : ''">
          <i *ngIf="!uploadData.file" class="pi pi-file"></i>
          <span *ngIf="uploadData.file" class="text-left border-0">{{ uploadData.file.name }}</span>
          <span *ngIf="!uploadData.file">No file uploaded</span>
        </div>

        <div *ngIf="uploadError" class="text-danger mt-1 err-font">{{ uploadError }}</div>
      </div>
      <div class="mb-3 filedetails">
        <p class="filesformat">Supported formats: PDF, JPG, JPEG, PNG.</p>
        <p class="filesformat">Maximum size: 15 MB.</p>
      </div>
      <div class="row mb-3 mt-3" [formGroup]="uploadDocMetaForm">
        <div class="col-sm-5">
          <label for="document_category" class="form-label custom-req-label">Document Category<span class="requiredfield text-danger">*</span></label>
          <p-dropdown
            inputId="document_category"
            [options]="categoryOptions"
            optionLabel="value"
            formControlName="category"
            optionValue="key"
            placeholder="Select Document Category"
            [filter]="true"
            filterBy="value"
            filterMatchMode="contains"
            styleClass="ufcustom-req-dropdown"
            (onChange)="onCategoryChange($event.value)">
          </p-dropdown>
              <div id="document_category_error" *ngIf="uploadDocMetaForm.get('category')?.invalid && uploadDocMetaForm.get('category')?.touched"> 
              <div class="text-danger mt-1 err-font">Document Category is required.</div>
            </div>
        </div>

        <div class="col-sm-5">
          <label for="document_type" class="form-label custom-req-label">Document Type<span class="requiredfield text-danger">*</span></label>
          <p-dropdown
            #uploadTypeDropdown
            inputId="document_type"
            [options]="filteredDocumentTypeOptions"
            optionLabel="value"
            formControlName="type"
            optionValue="key"
            placeholder="Select Document Type"
            [filter]="true"
            filterBy="value"
            filterMatchMode="contains"
            appendTo="body"
            [baseZIndex]="1100"
            panelStyleClass="lookup-upload-type-panel"
            (onShow)="onUploadTypeDropdownShow(uploadTypeDropdown)"
            styleClass="ufcustom-req-dropdown">
          </p-dropdown>
            <div id="document_type_error"  *ngIf="uploadDocMetaForm.get('type')?.invalid && uploadDocMetaForm.get('type')?.touched"> 
              <div class="text-danger mt-1 err-font">Document Type is required.</div>
            </div>
        </div>
      </div>
    </div>

    <div class="form-modal-footer p-3 d-flex">
      <button type="button" class="btn-cancel btn btn-md px-3 py-1" (click)="showCancelUploadConfirmation()">Cancel</button>
      <button class="btn btn-primary btn-md rounded ms-2" type="button" (click)="onSaveUploadFile()">Save</button>
    </div>
  </div>
</ng-template>
<!-- <div *ngIf="showDeleteModal" class="delete-modal custom-communication-delete-modal" id="communication_delete_modal">
  <div class="modal-content">
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
      <h4  class="form-modal-title">Delete Record</h4>
    </div>
<div class="form-modal-body p-3">
        <p class="para-content">Are you sure you want to delete this document?</p>
      <p class="para-content">This action cannot be undone.</p>
  </div>
    <div class="modal-actions">
      <button class="btn btn-secondary" (click)="closeDeleteModal()">Cancel</button>
      <button class="btn btn-danger" (click)="deleteNote(noteToDelete)">Delete</button>
    </div>
  </div>
</div> -->

<ng-template #viewNoteDetailModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h5 class="modal-title">View Note</h5>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg"
           (click)="closeViewNoteDetailModal()"
           (keypress)="closeViewNoteDetailModal()"
           alt="close_icon" tabindex="0">
    </div>
  </div>

  <div class="modal-body">
    <div class="row ml-0 mr-0">

      <!-- Date -->
      <div class="col-sm-12 col-md-6 col-lg-6 mb-3 relPos">
        <label for="view_note_date" class="form-label custom-req-label">Date</label>
        <div class="input-group ssn-input-group">
          <input type="text" id="view_note_date" class="form-control formField date-uppercase mt-1"
            [value]="selectedViewNote?.updated_date || '-'" placeholder="MM/DD/YYYY" maxlength="10" readonly />
          <span class="ssn-eye mt-1">
            <button type="button" class="mt-1 p-0 eye absoloutePos" tabindex="-1" disabled
              aria-label="Date picker disabled in view mode">
              <span class="material-symbols-outlined f-20 cal">calendar_month</span>
            </button>
          </span>
        </div>
      </div>

      <!-- Note Type -->
      <div class="col-sm-12 col-md-6 col-lg-6 mb-3 relPos">
        <label for="view_note_type" class="form-label custom-req-label">Note Type</label>
        <p-dropdown
          inputId="view_note_type"
          [options]="noteTypeOptions"
          [(ngModel)]="viewNoteTypeKey"
          [ngModelOptions]="{ standalone: true }"
          optionLabel="value"
          optionValue="key"
          placeholder="-"
          [filter]="false"
          styleClass="ufcustom-req-dropdown"
          [disabled]="true">
        </p-dropdown>
      </div>

            <!-- Updated By -->
      <!-- <div class="col-sm-12 col-md-4 col-lg-4 relPos mb-3">
        <label for="view_updated_by" class="form-label custom-req-label">Updated By</label>
        <div class="input-group ssn-input-group">
          <input type="text"
            id="view_updated_by"
            class="form-control formField mt-1"
            [value]="selectedViewNote?.updated_by || '-'"
            readonly />
        </div>
      </div> -->

      <!-- Updated Date -->
      <!-- <div class="col-sm-12 col-md-4 col-lg-4 mb-3 relPos">
        <label for="view_updated_date" class="form-label custom-req-label">Updated Date</label>
        <div class="input-group ssn-input-group">
          <input type="text"
            id="view_updated_date"
            class="form-control formField date-uppercase mt-1"
            [value]="selectedViewNote?.updated_date || '-'"
            placeholder="MM/DD/YYYY"
            maxlength="10"
            readonly />
          <span class="ssn-eye mt-1">
            <button type="button"
              class="mt-1 p-0 eye absoloutePos"
              tabindex="-1"
              disabled
              aria-label="Date picker disabled in view mode">
              <span class="material-symbols-outlined f-20 cal">calendar_month</span>
            </button>
          </span>
        </div>
      </div> -->

      <!-- Document Category -->
      <!-- <div class="col-sm-12 col-md-4 col-lg-4  relPos mb-3">
        <label for="view_document_category" class="form-label custom-req-label">
          Document Category
        </label>
        <p-dropdown
          inputId="view_document_category"
          [options]="categoryOptions"
          [(ngModel)]="viewDocumentCategoryId"
          [ngModelOptions]="{ standalone: true }"
          optionLabel="value"
          optionValue="id"
          placeholder="-"
          [filter]="false"
          styleClass="ufcustom-req-dropdown"
          [disabled]="true">
        </p-dropdown>
      </div> -->

      <!-- Document Type -->
      <!-- <div class="col-sm-12 col-md-4 col-lg-4 relPos mb-3">
        <label for="view_document_type" class="form-label custom-req-label">
          Document Type
        </label>
        <p-dropdown
          inputId="view_document_type"
          [options]="viewDocumentTypeOptions"
          [(ngModel)]="viewDocumentTypeId"
          [ngModelOptions]="{ standalone: true }"
          optionLabel="value"
          optionValue="id"
          placeholder="-"
          [filter]="false"
          styleClass="ufcustom-req-dropdown"
          [disabled]="true">
        </p-dropdown>
      </div> -->

            <!-- Supporting Document -->
      <!-- <div class="col-sm-6 col-md-6 col-lg-6 relPos mb-3">
        <label for="view_supporting_document" class="form-label custom-req-label">
          Supporting Document
        </label>
        <div class="supporting-doc-row-v1">
          <div class="doc-icon-slot">
            <span class="material-symbols-outlined">file_save</span>
          </div>
          <input id="view_supporting_document"
            type="text"
            class="form-control formField doc-name-input"
            [value]="selectedViewNote?.document_name || '-'"
            [title]="selectedViewNote?.document_name || '-'"
            readonly />
          <button type="button"
            class="replace-file-btn"
            [disabled]="!hasValidDocumentId(selectedViewNote)"
            (click)="viewNoteDocument(selectedViewNote)"
            pTooltip="View Document"
            tooltipPosition="top"
            tooltipStyleClass="pcustom-tooltip">
            <i class="fa fa-eye" aria-hidden="true"></i> View
          </button>
        </div>
      </div> -->

       <!-- Note -->
      <div class="col-sm-12 col-md-12 col-lg-12 relPos mb-3">
        <label for="view_note_text" class="form-label custom-req-label">Note</label>
        <div class="input-group ssn-input-group">
          <textarea
            id="view_note_text"
            rows="3"
            class="popup-autoheighttextarea form-control"
            [value]="selectedViewNote?.document_notes  || '-'"
            readonly></textarea>
        </div>
      </div>

    </div>




  </div>

  <div class="modal-footer">
    <button type="button"
      class="btn btn-outline-primary lookup-communication-btn-cancel"
      (click)="closeViewNoteDetailModal()">
      Close
    </button>
  </div>
</ng-template>

<ng-template #editNoteModal let-modal>
  <div class="modal-header d-flex justify-content-between align-items-center">
    <h4 class="modal-title">Edit Note</h4>
    <div class="btn-modal-close cursor-pointer">
      <img src="assets/images/neveda-images/close.svg" (click)="closeEditNoteModal()" 
           (keypress)="closeEditNoteModal()" alt="close_icon" tabindex="0">
    </div>
  </div>
  <div class="modal-body">
    <form [formGroup]="editNoteForm">
      <div class="row">

        <div class="col-sm-12 col-md-6 col-lg-6 mb-3 relPos">
          <label class="form-label custom-req-label" for="edit_note_date">
            Date <span class="text-danger">*</span>
          </label>
          <div class="input-group ssn-input-group">
            <input type="text" id="edit_note_date"
              class="form-control formField date-uppercase mt-1"
              formControlName="date"
              placeholder="MM/DD/YYYY"
              maxlength="10"
              (focus)="onDateFocus()"
              (blur)="onDateBlur()"
              (input)="formatDateInput($event)" readonly/>
              <!-- [ngClass]="{ 'is-invalid': editNoteForm.get('date')?.invalid && editNoteForm.get('date')?.touched }" readonly/> -->
            <span class="ssn-eye mt-1">
              <button type="button" class="mt-1 p-0 eye absoloutePos" tabindex="0"
                (click)="openEditNoteDatePicker($event)"
                (keypress)="openEditNoteDatePicker($event)"
                pTooltip="Open Calendar" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                aria-label="Open date picker" disabled>
                <span class="material-symbols-outlined f-20 cal">calendar_month</span>
              </button>
            </span>
          </div>
          <!-- <div *ngIf="editNoteForm.get('date')?.touched && editNoteForm.get('date')?.errors as dateErrors">
            <div *ngIf="dateErrors['required'] || dateErrors['futureDate']" class="text-danger mt-1 err-font">
              Select a valid date.
            </div>
            <div *ngIf="dateErrors['beforeDob']" class="text-danger mt-1 err-font">
              Date cannot be earlier than Date of Birth.
            </div>
          </div> -->
        </div>

        <div class="col-sm-12 col-md-6 col-lg-6 mb-3 relPos">
          <label class="form-label custom-req-label" for="edit_note_type">
            Note Type <span class="text-danger">*</span>
          </label>
          <p-dropdown
            inputId="edit_note_type"
            [options]="noteTypeOptions"
            formControlName="noteType"
            optionLabel="value"
            optionValue="key"
            placeholder="Select Note Type"
            [filter]="true"
            filterBy="value"
            filterMatchMode="contains"
            styleClass="ufcustom-req-dropdown"
            [ngClass]="{ 'is-invalid': editNoteForm.get('noteType')?.invalid && editNoteForm.get('noteType')?.touched }">
          </p-dropdown>
          <div *ngIf="editNoteForm.get('noteType')?.touched && editNoteForm.get('noteType')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            Note Type is required.
          </div>
        </div>

        <!-- <div class="col-md-6 relPos mb-3">
          <label class="form-label custom-req-label" for="edit_supporting_document">
            Supporting Document <span class="text-danger">*</span>
          </label>
          <div class="supporting-doc-row-v1">
            <div class="doc-icon-slot">
              <span class="material-symbols-outlined">file_save</span>
            </div>
            <input id="edit_supporting_document" type="text"
              class="form-control formField doc-name-input"
              formControlName="supportingDocument" readonly />
            <button type="button" class="replace-file-btn"
              (click)="onOpenEditNoteUploadWarning()"
              pTooltip="Upload file" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip">
              <img src="assets/images/neveda-images/upload.svg" alt="Upload" width="24" height="24" />
            </button>
          </div>
          <div *ngIf="editNoteForm.get('supportingDocument')?.touched && editNoteForm.get('supportingDocument')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            Supporting Document is required.
          </div>
        </div> -->

        <div class="col-sm-12 col-md-12 col-lg-12 relPos mb-3">
          <label class="form-label custom-req-label" for="edit_note_text">
            Note <span class="text-danger">*</span>
          </label>
          <textarea id="edit_note_text" rows="3"
            class="popup-autoheighttextarea form-control"
            formControlName="notes"
            placeholder="Enter Notes"
            maxlength="700"
            [ngClass]="{ 'is-invalid': editNoteForm.get('notes')?.invalid && editNoteForm.get('notes')?.touched }">
          </textarea>
          <div *ngIf="editNoteForm.get('notes')?.touched && editNoteForm.get('notes')?.errors?.['required']"
            class="text-danger mt-1 err-font">
            Notes is required.
          </div>
        </div>

      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4"
      (click)="onEditNoteReset()"
      [disabled]="editNoteForm.pristine">
      Reset
    </button>
    <button type="button" class="btn btn-primary btn-lg btnprimary"
      (click)="updateNote()"
      [disabled]="editNoteForm.pristine">
      Update
    </button>
  </div>
</ng-template>